module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card mx-4"
  }, [_c('div', {
    staticClass: "card-block p-4"
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Create your account")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat password"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Create Account")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-facebook",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("facebook")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-twitter",
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("twitter")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb0c04f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Register.vue
// module id = 578
// module chunks = 1